<template>
  <el-autocomplete
      ref="courseQuery"
      class="input-new-tag"
      value-key="cname"
      size="mini"
      v-model="inputValue"
      :fetch-suggestions="queryCourses"
      @select="onCourseSelected">
    <template
        class="popover-course" slot-scope="{ item }">
      <el-popover
          placement="left-start"
          trigger="hover"
          @mouseover.native="$store.state.timetableOptions.previewCourse = item"
      >
        <span
            effect="dark"
            :size="courseSize"
            :disable-transitions="true"
            slot="reference">{{ item.cname }}{{ item.rawTimeslot }}
        </span>
        <div class="addr">{{ item.dep_cname }}</div>
        <div class="addr">{{ item.teacher }}</div>
        <div class="addr">{{ item.type }}</div>
        <div class="addr">{{ item.credit }} 學分</div>
        <div class="addr">{{ item.rawTimeslot }}</div>
        <div class="addr">{{ item.reg_num }} /{{ item.num_limit }}</div>
      </el-popover>
    </template>
  </el-autocomplete>
</template>
<script>
export default {
  name: 'CourseQuery',
  props: {
    courseSize: {},
    position: {},
    showCourseInput: {},
    showPromptCourseInput: {},
  },
  data() {
    return {
      inputValue: ""
    }
  },
  methods: {
    queryCourses(input, handler) {
      let pos = this.position
      let options = this.courseOption
      let courses = this.allCourses
      let slotsFilled = this.coursesGroup.slotsFilled
      var results = Object.values(courses)
      results = results.filter(c => c !== undefined);
      results = results.filter(c => c.timeSchedules);
      results = results.filter(c => c.timeSchedules.includes(pos));
      results = results.filter(c => c.cname.includes(input));
      results = results.filter(c => !this.coursesGroup.list.includes(c))
      if (!options.allowCrash) {
        results = results.filter(function (c) {
          let slots = c.timeSchedules
          for (let s of slots) {
            if (slotsFilled[s]) {
              return false
            }
          }
          return true
        });
      }
      handler(results)
    },
    onCourseSelected(course) {
      this.updateCourse(course);
      this.$store.state.timetableOptions.previewCourse = null
      this.$nextTick(() => {
        this.$emit('update:showCourseInput', false)
        if(this.showPromptCourseInput){
          this.$emit('update:showPromptCourseInput', false)
        }
        this.inputValue = '';
        this.courseView.addingCourseGrid = null
      });
    },
  }
}
</script>
<style>

.popover-course {
  width: 300px
}

.input-new-tag {
  font-size: 8px;
  margin-left: 10px;
  margin-right: 10px;
  vertical-align: bottom;
  width: 100%;
}

</style>
